import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingFaceShapeDetectorConfig } from '@/data/landingConfig/landingFaceShapeDetectorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_FaceShapeDetector } from './schemaObject';

interface Props {}
const FaceShapeDetector: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_FaceShapeDetector} />
			<LandingTemplate
				data={landingFaceShapeDetectorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelFaceShapeDetector()}
			/>
		</>
	);
};

export default FaceShapeDetector;
